import TableCustomized from './TableCustomized';
import TableCustomizedNew from './TableCustomizedNew';

export default TableCustomized;

export { TableCustomizedNew };
